import { Loader2 } from "lucide-react"

interface LoadingModalProps {
    isOpen: boolean
    message?: string
}

export function LoadingModal({ isOpen, message = "Processing..." }: LoadingModalProps) {
    if (!isOpen) return null

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-white rounded-xl shadow-xl p-8 flex flex-col items-center justify-center gap-4 animate-in zoom-in-95 duration-200 min-w-[250px]">
                <Loader2 size={40} className="animate-spin text-[#D91F27]" />
                <p className="text-lg font-semibold text-gray-900">{message}</p>
            </div>
        </div>
    )
}
